import type { FaireProductEntity } from "../../entity_types/product";

export const p_hjhbyu7xcw: FaireProductEntity = {
  token: "p_hjhbyu7xcw",
  type: "product",
  name: "Down To Clown Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a22e5e1d25cac6f16bbef752a6241b4440df5cefc6c787b1df43122d0f9b7bf4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d7a94c5986b5c805887d37742d98717036efbf13bc20d77d7bd04af197e01a0.jpeg",
    "https://cdn.faire.com/fastly/ee610bc71c96f3017fe48ba0caa827ef68c443ca1b654eb9e4bcfcbe636ec7d2.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/c03fa86404c4e024b58d1327da16096e377eb6b816c62ac31f2ff10a9ab0b837.jpeg",
    "https://cdn.faire.com/fastly/3754ef544bcd75d03978de0a8c4ebdf1584dac03d0c84f9c38c3851e194fa6e0.jpeg"
  ],
  priceDollars: 6.75,
  description: "You could pop on that red nose, wig, and floppy shoes—or, better yet, just wear these socks. Same chaotic clown vibes, way less commitment.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:11.282Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
